import { Box, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import CustomNumberTextField from "../../unit/forms/CustomNumberTextField";
import CustomSelect from "../../unit/forms/CustomSelect";
import CustomSelectVerify from "../../unit/forms/CustomSelectVerify";
import useNotify from "../../unit/useNotify";
import { useRefresh } from "react-admin";
import { saveCachedMenuStats } from "../../layout/PreloadMenuStats";
import PaperComponent from "../../unit/PaperComponent";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
export default function CustomLoanUpdateStatusDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record: recordProp } = props;
  const lastDate = recordProp?.lastDate;
  const accruedInterestAmount = recordProp?.accruedInterestAmount;
  const [open, setOpen] = React.useState(false);
  const [changeLoanStatus, setChangeLoanStatus] = React.useState("Active");
  const [chargeOffAmount, setChargeOffAmount] = React.useState(
    recordProp?.loan?.activePrincipalBalance
  );
  const [paidOffAmount, setPaidOffAmount] = React.useState(
    recordProp?.loan?.payOffAmount
  );
  const [chargeOffAmountError, setChargeOffAmountError] = React.useState(false);
  const [paidOffAmountError, setPaidOffAmountError] = React.useState(false);
  const [chagedOffAmountShow, setChagedOffAmountShow] = React.useState(false);
  const [paidOffAmountShow, setPaidOffAmountShow] = React.useState(false);
  const [providedbyVal, setProvidedbyVal] = React.useState("");
  const refresh = useRefresh();

  const handleClickOpen = (event: any) => {
    const button = event.currentTarget;
    const data_action = button.getAttribute("data-action");
    // console.log("data_action =====>", data_action);
    setOpen(true);
    if (data_action == "paid-off") {
      setChangeLoanStatus("Paid-Off");
      setChagedOffAmountShow(false);
      setPaidOffAmountShow(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    // refresh();
  };

  const handleChangeLoanStatus = (e: any) => {
    setChangeLoanStatus(e.target.value);

    if (e.target.value == "Charged-Off") {
      setChagedOffAmountShow(true);
      setPaidOffAmountShow(false);
    } else if (e.target.value == "Paid-Off") {
      setChagedOffAmountShow(false);
      setPaidOffAmountShow(true);
    } else {
      setChagedOffAmountShow(false);
      setPaidOffAmountShow(false);
      // setChargeOffAmount(0);
      // setPaidOffAmount(0);
    }
  };
  return (
    <div>
      <Button
        id="button-loan-update-status"
        label="Update Status"
        variant="contained"
        size="medium"
        color="primary"
        sx={{ marginLeft: "10px", width: "175px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-loan-update-status"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.loannum = recordProp?.loan?.loanNum;
            // console.log("update loan status formJson =====>", formJson);

            const reqUrl = `loans/actions/loanstatus`;
            const responseBack = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            // console.log(responseBack.data);
            if (responseBack && responseBack.code == "200") {
              successNotify("Data saved successfully");
              if (changeLoanStatus != "Active") {
                let oldStatus = recordProp?.loan?.curStatus;
                // console.log("oldStatus=====>1111==>", oldStatus);
                if (oldStatus == "OK") {
                  if (
                    recordProp?.loan?.allModifyNum > 0 &&
                    recordProp?.loan?.allModifyNum < 3
                  ) {
                    oldStatus = "ok3";
                  } else if (
                    recordProp?.loan?.allModifyNum >= 3 &&
                    recordProp?.loan?.allModifyNum <= 6
                  ) {
                    oldStatus = "ok36";
                  } else if (recordProp?.loan?.allModifyNum > 6) {
                    oldStatus = "ok6";
                  }
                } else if (oldStatus == "Late") {
                  oldStatus = "late";
                } else if (
                  oldStatus == "30D" ||
                  oldStatus == "60D" ||
                  oldStatus == "30D"
                ) {
                  oldStatus = "large30D";
                }
                // console.log("oldStatus=====>", oldStatus);
                // console.log("changeLoanStatus=====>", changeLoanStatus);
                saveCachedMenuStats("loan", oldStatus, false, 1);
                saveCachedMenuStats("loan", changeLoanStatus, true, 1);
              }
              handleClose();
              refresh();
            } else {
              if (responseBack?.message) {
                errorNotify(responseBack?.message);
              } else {
                errorNotify("Data not saved!");
              }
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle title={`Active Loan`} subTitle="Update Status" />
        </DialogTitle>
        <DialogContent>
          <Box sx={{ height: "500px", minHeight: "300px" }}>
            <DialogContentText component="div">
              <Typography variant="body1" sx={{ color: "red" }}>
                This operation cannot be reversed. Please check all the inputs
                before clicking "Confirm" to proceed.
              </Typography>
            </DialogContentText>
            <Grid container sx={{ mt: 2, mb: 2, pb: 2 }}>
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle
                    fullWidth
                    title="Update Status To"
                    required={true}
                  />
                </Grid>
                <Grid item xs={5}>
                  <CustomSelectVerify
                    fullWidth
                    id="loan_status"
                    name="loan_status"
                    variant="outlined"
                    optionlist={[
                      { value: "Active", label: "Active Loan" },
                      { value: "Charged-Off", label: "Charged-Off Loan" },
                      { value: "Paid-Off", label: "Paid-Off Loan" },
                      { value: "Voided", label: "Voided Loan" },
                    ]}
                    defaultValue="Active"
                    value={changeLoanStatus}
                    onChange={(e) => {
                      handleChangeLoanStatus(e);
                    }}
                    required={true}
                    helperText="no"
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
              {/* Charge-Off, Paid-Off Amount  */}
              {chagedOffAmountShow && (
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle
                      fullWidth
                      title="Charge-Off Amount"
                      required={chagedOffAmountShow}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <CustomNumberTextField
                      fullWidth
                      id="chargeoffamount"
                      name="chargeoffamount"
                      variant="outlined"
                      defaultValue={chargeOffAmount}
                      // defaultValue={recordProp?.loan?.activePrincipalBalance}
                      onChange={(e) => {
                        setChargeOffAmount(e.target.value);
                        if (e.target.value < 0) {
                          setChargeOffAmountError(true);
                        } else {
                          setChargeOffAmountError(false);
                        }
                      }}
                      required={chagedOffAmountShow}
                      error={chargeOffAmountError}
                      helperText="no"
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              )}
              {paidOffAmountShow && (
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle
                      fullWidth
                      title="Paid-Off Amount"
                      required={paidOffAmountShow}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <CustomNumberTextField
                      fullWidth
                      id="paidoffamount"
                      name="paidoffamount"
                      variant="outlined"
                      defaultValue={paidOffAmount}
                      // defaultValue={recordProp?.loan?.payOffAmount}
                      onChange={(e) => {
                        setPaidOffAmount(e.target.value);
                        if (e.target.value < 0) {
                          setPaidOffAmountError(true);
                        } else {
                          setPaidOffAmountError(false);
                        }
                      }}
                      required={paidOffAmountShow}
                      error={paidOffAmountError}
                      helperText="no"
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              )}
              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle
                    fullWidth
                    title="Charge-Off / Paid-Off / Voided Date"
                    required={true}
                  />
                </Grid>
                <Grid item xs={5}>
                  <CustomDateTextInput
                    fullWidth
                    id="update_date"
                    name="update_date"
                    variant="standard"
                    defaultValue={new Date()}
                    required={true}
                    helperText="no"
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
              {/* Credit Score ， Number field */}

              <Grid sx={{ mb: 2 }} container>
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle fullWidth title="Credit Score" />
                </Grid>
                <Grid item xs={5} sx={{ paddingTop: "8px" }}>
                  <CustomNumberTextField
                    fullWidth
                    id="creditscoreval"
                    name="creditscoreval"
                    variant="outlined"
                    small
                    required={false}
                    helperText="no"
                  />
                </Grid>
                <Grid item xs={2} sx={{ paddingTop: "8px" }}></Grid>
              </Grid>
              <Grid sx={{ mb: 2 }} container>
                <Grid
                  item
                  xs={5}
                  sx={{
                    paddingTop: "15px",
                    textAlign: "left",
                    verticalAlign: "middle",
                  }}
                >
                  <HeaderLabelTitle fullWidth title="Provided By" />
                </Grid>
                <Grid item xs={5}>
                  <CustomSelect
                    id="providedby"
                    name="providedby"
                    variant="outlined"
                    value={providedbyVal}
                    optionlist={[
                      { value: "", label: "Select" },
                      { value: "Experian", label: "Experian" },
                      { value: "Equifax", label: "Equifax" },
                      { value: "Trans Union", label: "Trans Union" },
                      { value: "Composite", label: "Composite" },
                    ]}
                    onChange={(e) => {
                      setProvidedbyVal(e.target.value);
                    }}
                    helperText="no"
                  />
                </Grid>
                <Grid item xs={5}></Grid>
              </Grid>
              <Grid sx={{ mb: 2 }} container>
                <HeaderLabelTitle
                  title="Add Note (Max 150 Characters)"
                  suffix=""
                />
              </Grid>
              <Grid sx={{ mb: 2 }} container>
                <TextField
                  id="notes"
                  name="notes"
                  placeholder="Notes"
                  multiline={true}
                  minRows={3}
                  fullWidth
                  variant="outlined"
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Confirm" />
        </DialogActions>
      </Dialog>
    </div>
  );
}
